import { useRootStore } from '@nandosaus/state-management';
import { useFeature } from '@hooks/use-feature';
import { ORDER_TYPES } from '@nandosaus/constants';

const useShouldEnableRecommendationEngine = () => {
  const { CartStore } = useRootStore();
  const recommendationEngineWhiteList = useFeature('recommendations-engine-restaurant-whitelist');
  const hideCateringRecommendationEngine = useFeature('hide-catering-recommendation-engine');

  const isCateringAllowed = CartStore.orderType === ORDER_TYPES.CATERING && !hideCateringRecommendationEngine;
  const isDineInAllowed = CartStore.orderType === ORDER_TYPES.DINE_IN;

  return (
    (isDineInAllowed || isCateringAllowed) &&
    recommendationEngineWhiteList?.restaurants?.includes(CartStore.restaurantId)
  );
};

export { useShouldEnableRecommendationEngine };
